<script>
import Component from '~/sites/cvb/pages/index'
export default {
  extends: Component,
}
</script>
